import { render } from "./TestEmailsPage.vue?vue&type=template&id=f038e9b4"
import script from "./TestEmailsPage.vue?vue&type=script&lang=js"
export * from "./TestEmailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__